import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style9({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="squared"
      activeItemNameKey="codeName"
      onClick={onClick}
    />
  );
}
